import { Brand } from '@lendi/lala-react';
import { IconProps } from '@lendi-ui/icon';
import InsertChart from '@lendi-ui/icon/InsertChart';
import Search from '@lendi-ui/icon/Search';
import BorderColor from '@lendi-ui/icon/BorderColor';
import ChromeReaderMode from '@lendi-ui/icon/ChromeReaderMode';
import HomeAccount from '@lendi-ui/icon/HomeAccount';
import LockOpen from '@lendi-ui/icon/LockOpen';
import RefinanceHome from '@lendi-ui/icon/RefinanceHome';
import AttachMoney from '@lendi-ui/icon/AttachMoney';
import Queue from '@lendi-ui/icon/Queue';

import { getBaseUrl } from './getBaseUrl';
import { getBrand } from './getBrand';
import { getEnv } from './getEnv';

const brand = getBrand();
const env = getEnv();

export type Tool = {
  key: string;
  label: string;
  Icon: (props: IconProps) => JSX.Element;
  url: string;
};

export type Tools = {
  key: string;
  category: string;
  items: Tool[];
};

const commonTools: Tools = {
  key: 'broker-tools',
  category: 'Broker Tools',
  items: [
    {
      key: 'sandbox',
      label: 'Sandbox',
      Icon: ChromeReaderMode,
      url: `${getBaseUrl(brand, env)}/servicing-sandbox`,
    },
    {
      key: 'funding-position',
      label: 'Initial Funding\nPosition',
      Icon: InsertChart,
      url: `${getBaseUrl(brand, env)}/funding-position`,
    },
    {
      key: 'product-search',
      label: 'Product\nSearch',
      Icon: Search,
      url: `${getBaseUrl(brand, env)}/product-search`,
    },
  ],
};

export const getBrandTools = (brand: Brand): Tools[] => {
  if (brand === Brand.Aussie) {
    return [
      {
        ...commonTools,
        items: [
          ...commonTools.items,
          {
            key: 'docusign',
            label: 'Docusign',
            Icon: BorderColor,
            url: `https://account.docusign.com/`,
          },
        ],
      },
      {
        key: 'calculators',
        category: 'Calculators',
        items: [
          {
            key: 'borrowing-power',
            label: 'Borrowing Power Calculator',
            Icon: HomeAccount,
            url: `${getBaseUrl(Brand.Aussie, env, true)}/calculators/borrowing-power`,
          },
          {
            key: 'fixed-rate-expiry',
            label: 'Fixed Rate Expiry Calculator',
            Icon: LockOpen,
            url: `${getBaseUrl(Brand.Aussie, env, true)}/calculators/fixed-rate-expiry`,
          },
          {
            key: 'mortgage-repayments',
            label: 'Repayments Calculator',
            Icon: RefinanceHome,
            url: `${getBaseUrl(Brand.Aussie, env, true)}/calculators/mortgage-repayments`,
          },
          {
            key: 'mortgage-deposit-calculator',
            label: 'Deposit\nCalculator',
            Icon: AttachMoney,
            url: `${getBaseUrl(Brand.Aussie, env, true)}/calculators/mortgage-deposit-calculator`,
          },
          {
            key: 'mortgage-extra-repayment-calculator',
            label: 'Extra Repayments Calculator',
            Icon: Queue,
            url: `${getBaseUrl(Brand.Aussie, env, true)}/calculators/mortgage-extra-repayment-calculator`,
          },
        ],
      },
    ];
  }
  return [commonTools];
};
